export const getMaxResultsByCodeListName = (name: string): number => {
  switch (name) {
    case 'DiscoCode':
      return 100;
    default:
      return 50;
  }
};
